<template>
    <v-dialog persistent v-model="dialog" width=50%>
        <v-card class="px-2">
            <v-container>
                <!-- header info -->
                <v-row class="pa-4"><h3>Booking.com Reporting API</h3></v-row>
                <v-row class="pl-4 mt-6">Booking {{ huov.huov_code }} / {{ huov.huov_ota_code }}</v-row>

                <v-row><v-divider></v-divider></v-row>
                <v-row class="pl-4 mt-6">
                    <v-btn color="primary mx-2" small @click="runReportingAPI('cc_is_invalid')" :loading="loading">Guest provided invalid credit card</v-btn> 
                </v-row>
                <v-row class="pl-4 mt-6">
                    <v-btn color="primary mx-2" small @click="startCheckinChange()" :loading="loading">Start changes to check-out date and/or price</v-btn> 
                </v-row>
                <v-row class="pl-4 mt-6">
                    <v-btn color="primary mx-2" small @click="runReportingAPI('is_no_show')" :loading="loading">Cancellation due to guest no-show</v-btn> 
                </v-row>
                <v-row class="pl-4 mt-6">
                    <v-btn color="primary mx-2" small @click="runReportingAPI('cancel_reservation_invalid_cc')" :loading="loading">Cancellation due to invalid credit card</v-btn> 
                </v-row>
                <v-row class="pl-4 mt-6">
                    <v-btn color="primary mx-2" small @click="getMisconductCategory()" :loading="loading">Start Guest misconduct</v-btn> 
                </v-row>
                





                <v-row class="pl-4 mt-6">
                    <v-col v-if="showCheckinChange">
                        <v-row no-gutters> 
                            <v-col cols="6" class="pa-2">
                                <date_picker label="Checkin Date"                                 
                                            :date="checkin"
                                            :startDate="checkin"
                                            field="checkin" 
                                            icon="mdi-calendar-month-outline"
                                            @updateData="updateData"
                                            outlined
                                            dense></date_picker> 
                            </v-col>
                            <v-col cols="6" class="pa-2">
                                <date_picker label="Checkout Date"                                 
                                            :date="checkout"
                                            :startDate="checkin"
                                            field="checkout" 
                                            icon="mdi-calendar-month-outline"
                                            @updateData="updateData"
                                            outlined
                                            dense></date_picker> 
                            </v-col>
                         </v-row>
                         <v-row no-gutters>
                            <v-col>
                                <v-text-field v-model="price" dense outlined label="Price (rounded)" name="price"></v-text-field>
                            </v-col>
                        </v-row>  
                        <v-row no-gutters>
                            <v-col>
                                <v-btn 
                                    color="primary mx-2" 
                                    small 
                                    @click="runReportingAPI('stay_change')" :loading="loading">Send Changes</v-btn> 
                            </v-col>
                        </v-row>
                    </v-col>
                    
                    
                    
                    <v-col v-if="guest_misconduct">
                        
                        <v-row v-if="categoryKeuzes.length > 0">
                            <v-col>
                            <v-select v-if="categoryKeuzes.length > 0"
                                :items="categoryKeuzes"
                                label="Misconduct Category"
                                item-text="category-name"
                                item-value="category-id"
                                outlined
                                dense
                                v-model="category"
                            ></v-select>
                        </v-col>
                        </v-row>
                        <v-row v-if="filteredSubCategory.length > 0 && category !== ''">
                            <v-col>
                            <v-select v-if="filteredSubCategory.length > 0 && category !== ''"
                                :items="filteredSubCategory"
                                label="Misconduct SubCategory"
                                item-text="subcategory-name"
                                item-value="subcategory-id"
                                v-model="subcategory"
                                outlined
                                dense
                            ></v-select>
                        </v-col>
                        </v-row>
                        <v-row no-gutters v-for="(filteredAdditional_field,i) in filteredAdditional_fields" :key="i">
                            <v-col>
                            <v-text-field dense v-model="fields[i]" outlined v-if="!filteredAdditional_field['has-possible-values']" :label="filteredAdditional_field['additional-field-description']" :name="filteredAdditional_field['additional-field-name']">
                            </v-text-field>

                            <v-select v-if="filteredAdditional_field['has-possible-values']"
                                :items="filteredPossible_values(category,filteredAdditional_field['additional-field-name'])"
                                :label="filteredAdditional_field['additional-field-description']"
                                item-text="possible-description"
                                item-value="possible-value"
                                outlined
                                dense
                                v-model="fields[i]"
                            ></v-select>
                            </v-col>
                        </v-row>
                        
                        <v-row no-gutters v-if="category !== ''">
                            <v-col>
                                <v-text-field v-model="details_text" dense outlined label="Details of the misconduct (optional, max 240 characters)" name="details_text"></v-text-field>
                            </v-col>
                        </v-row>

                        <v-row no-gutters v-if="category !== ''">
                            <v-col>
                                <v-select 
                                    :items="yesno"
                                    label="should Booking.com follow up on this incident?"
                                    v-model="escalate_report"
                                    item-text="key"
                                    item-value="value"
                                    outlined
                                    dense
                                ></v-select>
                            </v-col>
                        </v-row>

                        <v-row no-gutters v-if="category !== ''">
                            <v-col>
                                <v-select 
                                    :items="yesno"
                                    label="Allow this guest to book property again?"
                                    v-model="rebooking_allowed"
                                    item-text="key"
                                    item-value="value"
                                    outlined
                                    dense
                                ></v-select>
                            </v-col>
                        </v-row>

                        <v-row no-gutters>
                            <v-col>
                                <v-btn 
                                    color="primary mx-2" 
                                    small 
                                    @click="runReportingAPI('guest_misconduct')" :loading="loading">Send Guest misconduct</v-btn> 
                            </v-col>
                        </v-row>

                    </v-col>
                </v-row>
                

                

                <v-row v-if="request_string !== ''" class="mt-6 mb-6"><v-divider></v-divider></v-row>
                <v-row v-if="request_string !== ''" class="pl-4 mt-6">
                    <v-col>
                        <v-row no-gutters>
                            <v-col>Request</v-col>
                        </v-row>
                        <v-row no-gutters>
                            <v-col>
                                <code>{{ request_string }}</code>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
                <v-row v-if="response !== ''" class="mt-6 mb-6"><v-divider></v-divider></v-row>
                <v-row v-if="response !== ''" class="pl-4 mt-6">
                    <v-col>
                        <v-row no-gutters>
                            <v-col>Response</v-col>
                        </v-row>
                        <v-row no-gutters>
                            <v-col>
                                <code>{{ response }}</code>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>

                <v-row class="mt-6 mb-6"><v-divider></v-divider></v-row>

                
                <v-card-actions>
                    <v-spacer />
                    <v-btn color="primary" small v-on:click="closeDialog()">Close</v-btn>
                </v-card-actions>
            </v-container>
        </v-card>

    </v-dialog>
</template>

<script>
import date_picker from '@/components/ui/date_picker.vue';
export default {
    props: {
            huov_encrid: String
    },
    components: {
        date_picker
    },
    data() {
        return {
            dialog: false,
            gebr_code:'',
            hosm_gebr:'',    
            hsmr_text: '',
            huov: '',
            categoryKeuzes: [],
            subcategoryKeuzes: [],
            additional_fieldsKeuzes: [],
            possible_valuesKeuzes: [],
            category: '',
            subcategory: '',
            additional_fields: '',
            possible_values: '',
            guest_misconduct: false,
            request_object: null,
            fields: [],
            yesno: [
                {"key": "Yes", "value": "1"}, {"key":"No", "value": "0"}
            ],
            escalate_report: '',
            rebooking_allowed: '',
            details_text: '',
            showCheckinChange: false,
            checkin: null,
            checkout: null,
            price: '',
            request_string: '',
            response: '',
            loading: false,
        }
    },
    computed: {
        filteredSubCategory() {
            return this.subcategoryKeuzes.filter(subcategory => {
                if (subcategory['category-id'] == this.category){
                    return subcategory;
                }
            })
        },
        filteredAdditional_fields() {
            return this.additional_fieldsKeuzes.filter(addition_field => {
                if (addition_field['category-id'] == this.category){
                    return addition_field;
                }
            })
        },
    },  
    methods: {
        open(huov_encrid) {
            this.loading = true;
            this.$emit("showSnackbar");
            this.dialog = true;
            this.category = '',
            this.subcategory = '',
            this.additional_fields = [],
            this.possible_values = '',
            this.$axios
            .post("ares/json/ares/huov/getHuovOtaCode.p", {
                header: {
                    token: this.$session.get("ARES"),
                    clientSessionId: this.$session.id(),
                    request: "getHuovOtaCode",
                },
                getHuovOtaCode: {
                    huov_encrid: huov_encrid,
                },
            })
            .then((res) => {
                if (res.data.error) {
                    console.log(res.data.error);
                } else {
                    this.huov = res.data.getHuovOtaCode;
                    this.ready = true;
                }
            })
            .finally(() => {
                this.loading = false;
            });
        },
        runReportingAPI(action) {
            this.loading = true;
            if(action == 'guest_misconduct'){
                this.filteredAdditional_fields.forEach(
                    (element,index) => this.additional_fields.push({"name":element['additional-field-name'],"value":this.fields[index]})
                );
            }

            this.$axios
                .post("ares/json/ares/huov/ota/bookingcom/sendReportingApi.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "sendReportingApi"
                    },
                    sendReportingApi: {
                        huov_encrid: this.huov.huov_encrid,
                        action: action,
                        category: this.category,
                        subcategory: this.subcategory,
                        additional_fields: this.additional_fields,
                        field: this.fields,
                        escalate_report: this.escalate_report,
                        rebooking_allowed: this.rebooking_allowed,
                        details_text: this.details_text,
                        checkin: this.$moment(this.checkin).format('YYYY-MM-DD'),  
                        checkout: this.$moment(this.checkout).format('YYYY-MM-DD'),  
                        price: this.price,

                    }
                })
                .then(res => {
                    if (res.data.error) {
                        console.log(res.data.error);
                        // laten we hopen dat dit nooit gebeurt, we zetten de gebruiker vast in dit dialog met een melding of iets
                    } else {
                        //this.$emit('updateData', 'refresh');
                        this.request_string = res.data.sendReportingApi.request_string;
                        this.response = res.data.sendReportingApi.response;
                        this.guest_misconduct = false;
                        this.showCheckinChange = false;
                        //this.dialog = false;
                    }
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        getMisconductCategory() {
            this.loading = true;
            this.$axios
                .post("ares/json/ares/huov/ota/bookingcom/getMisconductcategory.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getMisconductcategory"
                    },
                    getMisconductcategory: {
                        huov_encrid: this.huov.huov_encrid,
                    }
                })
                .then(res => {
                    if (res.data.error) {
                        console.log(res.data.error);
                        // laten we hopen dat dit nooit gebeurt, we zetten de gebruiker vast in dit dialog met een melding of iets
                    } else {
                        //this.$emit('updateData', 'refresh');
                        
                        this.categoryKeuzes = res.data.getMisconductcategory.category;
                        this.subcategoryKeuzes = res.data.getMisconductcategory.subcategory;
                        this.additional_fieldsKeuzes = res.data.getMisconductcategory.additional_fields;
                        this.possible_valuesKeuzes = res.data.getMisconductcategory.possible_values;
                        this.guest_misconduct = true;
                        this.showCheckinChange = false;
                        //this.dialog = false;

                    }
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        filteredPossible_values(category_id,field_name) {
            return this.possible_valuesKeuzes.filter(possible_value => {
                if (possible_value['category-id'] == category_id && possible_value['additional-field-name'] == field_name){
                    return possible_value;
                }
            })
        },
        startCheckinChange(){
            this.loading = true;
            this.$axios
                .post("ares/json/ares/huov/ota/bookingcom/getCheckin.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getCheckin"
                    },
                    getCheckin: {
                        huov_encrid: this.huov.huov_encrid,
                    }
                })
                .then(res => {
                    if (res.data.error) {
                        console.log(res.data.error);
                        // laten we hopen dat dit nooit gebeurt, we zetten de gebruiker vast in dit dialog met een melding of iets
                    } else {
                        //this.$emit('updateData', 'refresh');
                        this.checkin = res.data.getCheckin.checkin;
                        this.checkout = res.data.getCheckin.checkout;
                        this.price = res.data.getCheckin.price;
                        this.showCheckinChange = true;
                        this.guest_misconduct = false;
                        //this.dialog = false;

                    }
                })
                .finally(() => {
                    this.loading = false;
                });
            
            
        },
        updateData(data){
            this[data.field] = data.value;
        },
        closeDialog(){
            this.dialog = false;
            this.guest_misconduct = false;
            this.showCheckinChange = false;
            this.request_string = '';
            this.response = '';
        },
    }
}
</script>

<style scoped>
</style>